import React, { useEffect } from 'react'
import { Grid, } from '@material-ui/core';
import Controls from "../../../controls/Controls";
import { useForm, Form } from '../../../controls/useForm';


const initialFValues = {
    count: "",
    locationName: "",
    productName: "",
    firstName: "",
    lastName: "",
    actualInStore: "",
    differences: "",
    dateCounted: "",
}

export default function InventoryCountForm(props) {
    const { addOrEdit, recordForEdit, products, locations } = props
    const validate = (fieldValues = values) => {
        let temp = { ...errors }
        if ('count' in fieldValues)
            temp.count = fieldValues.count
        if ('locationName' in fieldValues)
            temp.locationName = fieldValues.locationName
        if ('productName' in fieldValues)
            temp.productName = fieldValues.productName
        if ('firstName' in fieldValues)
            temp.firstName = fieldValues.firstName
        if ('lastName' in fieldValues)
            temp.lastName = fieldValues.lastName
        if ('actualInStore' in fieldValues)
            temp.actualInStore = fieldValues.actualInStore
        if ('differences' in fieldValues)
            temp.differences = fieldValues.differences
        if ('dateCounted' in fieldValues)
            temp.dateCounted = fieldValues.dateCounted
        setErrors({
            ...temp
        })

        if (fieldValues === values)
            return Object.values(temp).every(x => x === "")
    }

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetForm
    } = useForm(initialFValues, true, validate);

    const handleSubmit = e => {
        e.preventDefault()
        if (validate()) {
            addOrEdit(values, resetForm);
        }
    }

    useEffect(() => {
        if (recordForEdit !== null)
            setValues({
                ...recordForEdit
            })
    }, [recordForEdit])

    return (
        <Form onSubmit={handleSubmit}>
            <Grid container>
                <Grid item xs={6}>
                    <Controls.Input
                        name="count"
                        label="Count"
                        readOnly={true}
                        value={values.count || ''}
                        onChange={handleInputChange}
                        error={errors.count}
                    />
                    <Controls.Input
                        name="locationName"
                        label="Location Name"
                        readOnly={true}
                        value={values.locationName || ''}
                        onChange={handleInputChange}
                        error={errors.locationName}
                    />
                    <Controls.Input
                        label="Product"
                        name="productName"
                        readOnly={true}
                        value={values.productName || ''}
                        onChange={handleInputChange}
                        error={errors.productName}
                    />

                    <Controls.Input
                        label="Date Counted"
                        name="dateCounted"
                        readOnly={true}
                        value={values.dateCounted || ''}
                        onChange={handleInputChange}
                        error={errors.dateCounted}
                    />

                </Grid>

                <Grid item xs={6}>
                <Controls.Input
                    label="First Name"
                    name="firstName"
                    readOnly={true}
                    value={values.firstName || ''}
                    onChange={handleInputChange}
                    error={errors.firstName}
                />
                <Controls.Input
                    label="Last Name"
                    name="lastName"
                    readOnly={true}
                    value={values.lastName || ''}
                    onChange={handleInputChange}
                    error={errors.lastName}
                />
                <Controls.Input
                    label="Actual In Store"
                    name="actualInStore"
                    readOnly={true}
                    value={values.actualInStore || ''}
                    onChange={handleInputChange}
                    error={errors.actualInStore}
                />
                <Controls.Input
                    label="Difference"
                    name="differences"
                    readOnly={true}
                    value={values.differences || ''}
                    onChange={handleInputChange}
                    error={errors.differences}
                />
               

            </Grid>
            </Grid>
        </Form>
    )
}
